/**
 * Đích alias của `resize-observer-polyfill` (xem internals/webpack/webpack.base.babel.js).
 * ResizeObserver là API gốc từ 2020, không cần polyfill 33 KB nữa.
 * Lớp rỗng để trình duyệt quá cũ mất tính năng chứ không vỡ app.
 */

const NoopResizeObserver = class {
  public observe(): void {
    /* noop */
  }
  public unobserve(): void {
    /* noop */
  }
  public disconnect(): void {
    /* noop */
  }
};

export default typeof window !== 'undefined' && (window as any).ResizeObserver
  ? (window as any).ResizeObserver
  : NoopResizeObserver;
